import colors from './colors'
import typography from './typography'

const baseUnit = 4
export const theme = {
    baseUnit,
    colors,
    typography,
    boxShadow: {
        0: '0.02em 0.04em 0.02em rgba(20, 40, 60, 0.4)',
        5: '0em 1em 2em rgba(20,40,60,0.4)',
        accent1: '0.0675em 0.125em var(--colors-primary-main)',
        accent2: '0.25em 0.75em var(--colors-primary-main)',
        accent10: '0.75em 0.625em var(--colors-primary-main)',
    },
    textBorder:
        '-0.025rem -0.025rem 0 var(--colors-grays-100), 0.025rem -0.025rem 0 var(--colors-grays-100), -0.025rem 0.025rem 0 var(--colors-grays-100), 0.025rem 0.025rem 0 var(--colors-grays-100);',
    borders: {
        main: '0.025rem solid var(--colors-grays-80)',
        soft: '0.025rem solid var(--colors-grays-40)',
    },
    bordersThick: { main: '0.125em solid var(--colors-grays-100)' },
    // The borderRadius by container
    borderRadius: {
        sm: '0.75rem',
        l: '1.9rem',
        xl: '1.2rem',
    },
    borderThickness: {},
}

export default theme
